import loadable from '@loadable/component';

export const RateRecommendedCandidateLoadable = loadable(
  () =>
    import(
      /* webpackChunkName: "RateRecommendedCandidate" */
      './RateRecommendedCandidate.dynamic'
    ),
);
